import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import {
    Container,
    Grid,
    Paper,
    CircularProgress,
    MenuItem
} from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import ReactTable from 'Components/ReactTable/ReactTable';
import { CustomModal } from 'Components/Modal/CustomModal';
import { Add } from 'Pages/InnerPages/OperatorWiseViewProvider/Add';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { Select as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
import { Select as SELECT } from 'Components/Api/OperatorWiseViewProviderApi';
import { Delete as DELETE } from 'Components/Api/OperatorWiseViewProviderApi';
import { BulkDelete as BULK_DELETE } from 'Components/Api/OperatorWiseViewProviderApi';
import { SelectByPrimeServices as SERVICE_SELECT_PRIME } from 'Components/Api/ServiceApi';
import {
    PLEASE_SELECT_VALID,
    MESSAGE_CLOSE_AFTER
} from 'Components/Helper/Messages';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
const CustomContainer = HOCLoader(Container);

export const OperatorWiseViewProvider = () => {
    const classes = commonStyle();
    const [Services, setServices] = useState([]);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [operators, setOperators] = useState([]);
    const [operatorID, setOperatorID] = useState(0);
    const [serviceID, setServiceID] = useState(0);
    const [operatorName, setOperatorName] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [responseMessage, setResponseMessage] = useState('');
    const [mainColumns, setMainColumns] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [datalist, setDatalist] = useState([]);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [
        shouldGetUpdatedDataFromTable,
        setShouldGetUpdatedDataFromTable
    ] = useState(false);
    const [isStatusCheckAllClicked, setIsStatusCheckAllClicked] = useState(
        false
    );

    useEffect(() => {
        setLoadingOpen(true);
        createColumns();
        selectServices();
        select();
    }, []);

    const [formObject, setFormObject] = useState({
        ServiceID: '',
        OperatorID: ''
    });

    const FormValidationSchema = Yup.object({
        ServiceID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'service')
            .required(PLEASE_SELECT_VALID + 'service'),
        OperatorID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'operator')
            .required(PLEASE_SELECT_VALID + 'operator')
    });

    const selectServices = async () => {
        const response = await SERVICE_SELECT_PRIME();
        if (!response.isAuthorized) LOGOUT();

        var data = JSON.parse(response.data);
        setLoadingOpen(false);
        setServices(data);
    };
    const operatorsList = operators.map(({ OperatorID, OperatorName }) => (
        <MenuItem key={OperatorName} value={OperatorID}>
            {OperatorName}
        </MenuItem>
    ));

    const OnOperatorChange = async (name, value) => {
        var ServiceID = value; //event.target.value;
        setServiceID(ServiceID);
        selectOperator(ServiceID);
    };

    const OnOperatorSelect = (name, value) => {
        const selectedOp = operators.find(
            (op) => op.OperatorID === parseInt(value)
        );
    };

    const selectOperator = async (ServiceID) => {
        if (
            ServiceID === null ||
            ServiceID === undefined ||
            ServiceID === 0 ||
            ServiceID === '0'
        )
            return;
        var requestObj = {
            ServiceID: ServiceID
        };
        let request = JSON.stringify(requestObj);

        const {
            isAuthorized,
            status,
            data
        } = await OPERATOR_SELECT_BY_SERVICEID(request);

        if (!isAuthorized) LOGOUT();

        if (!status) setIsError(true);

        if (data !== 'Requested operators not found') {
            const parsedOperators = JSON.parse(data);
            setOperators(parsedOperators);
        }
    };

    const ADD = (value) => {
        const selectedOperator = operators.find(
            (op) => op.OperatorID === parseInt(value.OperatorID)
        );
        const selectedServiceID = value.ServiceID;
        setIsModalOpen(true);
        setLoadingOpen(false);
        setOperatorID(selectedOperator.OperatorID);
        setServiceID(selectedServiceID);
        setOperatorName(setOperatorName(selectedOperator.OperatorName));
    };

    const select = async () => {
        setLoadingOpen(true);
        setDatalist([]);
        const response = await SELECT();

        setLoadingOpen(false);

        const { isAuthorized, status, data } = response;

        if (!isAuthorized) LOGOUT();
        if (!status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(data);
            return;
        }

        var list = JSON.parse(data);

        setDatalist(list);
    };

    const onDeleteClick = (item) => {
        var RequestObj = { OperatorWiseViewProviderID: item };
        setIsAlertOpen(true);
        setConfirmAlertRequest(RequestObj);
    };

    const Delete = async (request) => {
        var jsonReq = JSON.stringify(request);
        const response = await DELETE(jsonReq);
        if (!response.isAuthorized) LOGOUT();
        setIsError(true);
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }

        setSeverity('success');
        setResponseMessage(response.data);
        select();
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'OperatorWiseViewProviderID',
            srno: true
        });
        columns.push({
            label: 'Operator',
            name: 'OperatorName'
        });

        columns.push({
            label: 'ViewProvider',
            name: 'ViewProvider',
            array: true,
            keyName: 'ProviderName'
        });

        columns.push({
            label: 'Delete',
            name: 'OperatorWiseViewProviderID',
            delete: true,
            callback: (value) => {
                onDeleteClick(value);
            }
        });

        setMainColumns(columns);
    };

    const handleStatusCheckAllClick = (e) => {
        setShouldGetUpdatedDataFromTable(true);
        setIsStatusCheckAllClicked(true);
    };

    const DeleteMultiple = async (requestArr) => {
        setIsStatusCheckAllClicked(false);

        if (requestArr.length <= 0) {
            setSeverity('error');
            setResponseMessage(
                'Please select one or more transactions to Delete'
            );
            setIsError(true);
            return;
        }
        let request = [];

        requestArr.forEach((element) => {
            let { value } = element[0];
            request.push({ OperatorWiseViewProviderID: value });
        });

        setLoadingOpen(true);

        let { isAuthorized, status, data } = await BULK_DELETE(
            JSON.stringify(request)
        );
        setLoadingOpen(false);

        if (!isAuthorized) LOGOUT();

        setResponseMessage(data);

        if (!status) {
            setSeverity('error');
            setIsError(true);
            return;
        }
        setSeverity('success');
        setIsError(true);
        setTimeout(() => {
            select();
        }, MESSAGE_CLOSE_AFTER);
    };

    const ProcessUpdatedData = (data) => {
        setShouldGetUpdatedDataFromTable(false);

        if (isStatusCheckAllClicked) {
            DeleteMultiple(data);
            return;
        }
    };
    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={ADD}
                resetForm={formObject}
            >
                {() => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>
                                Operator Wise ViewProvider
                            </h2>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialSelect
                                                label="Service"
                                                name="ServiceID"
                                                onCustomCallback={(
                                                    name,
                                                    value
                                                ) => {
                                                    OnOperatorChange(
                                                        name,
                                                        value
                                                    );
                                                }}
                                                title="Select Service"
                                            >
                                                <MenuItem key="0" value="0">
                                                    Select Service
                                                </MenuItem>
                                                {Services.map((Item) => (
                                                    <MenuItem
                                                        key={Item.ServiceID}
                                                        value={Item.ServiceID}
                                                    >
                                                        {Item.ServiceName}
                                                    </MenuItem>
                                                ))}
                                            </MaterialSelect>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialSelect
                                                label="Operator"
                                                name="OperatorID"
                                                title="Operator"
                                                onCustomCallback={(
                                                    name,
                                                    value
                                                ) => {
                                                    OnOperatorSelect(
                                                        name,
                                                        value
                                                    );
                                                }}
                                            >
                                                <MenuItem key="0" value={0}>
                                                    Select Operator
                                                </MenuItem>
                                                {operatorsList}
                                            </MaterialSelect>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={1}
                                            lg={1}
                                        >
                                            <PrimaryButton
                                                type="submit"
                                                title="Add"
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                disabled={loadingOpen}
                                            >
                                                Add
                                            </PrimaryButton>
                                            {loadingOpen && (
                                                <CircularProgress
                                                    size={24}
                                                    className={
                                                        classes.buttonProgress
                                                    }
                                                />
                                            )}
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <SecondaryButton
                                                type="button"
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                style={{
                                                    background: 'green',
                                                    marginLeft: '16px'
                                                }}
                                                disabled={loadingOpen}
                                                title="Delete"
                                                onClick={
                                                    handleStatusCheckAllClick
                                                }
                                                fullWidth
                                            >
                                                Delete
                                            </SecondaryButton>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>

            {isModalOpen && (
                <CustomModal
                    isOpen={isModalOpen}
                    title="OperatorWise View Provider"
                    width="75%"
                    onDismissCallback={(value) => {
                        setIsModalOpen(value);
                    }}
                >
                    <Add
                        OperatorID={operatorID}
                        OperatorName={operatorName}
                        ServiceID={serviceID}
                        setIsModalOpen={setIsModalOpen}
                        onDismissCallback={(value) => {
                            setIsModalOpen(false);
                             select();
                        }}
                    />
                </CustomModal>
            )}

            {isAlertOpen ? (
                <ConfirmAlert
                    isOpen={isAlertOpen}
                    title="Delete Confirmation"
                    message="Are you sure to delete this Operator"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        Delete(request);
                    }}
                    negativeButtonClick={() => {
                                                   setIsAlertOpen(false);
                                               }}
                />
            ) : null}
            <ReactTable
                data={datalist}
                columns={mainColumns}
                getUpdatedData={(data) => {
                    ProcessUpdatedData(data);
                    setShouldGetUpdatedDataFromTable(false);
                }}
                shouldGetUpdatedData={shouldGetUpdatedDataFromTable}
                isSelectableRows={'multiple'}
            />
        </CustomContainer>
    );
};
